<virtual-keyboard (onEnteredText)="onEnteredText($event)" (onTextChanged)="onTextChanged()" [hidden]="!isVirtualKeyboardVisible"
    [keyboardType]="keyboardType" [isDisabled]="isDisabled" [textLength]="ticketLength" [separatorPosition]="separatorPosition"></virtual-keyboard>
